var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Type } from "class-transformer";
import isBlank from "@sedan-utils/is-blank";
export class SearchInfoWrapper {
    constructor(searchKey, pagination, result, source = "") {
        this.searchKey = searchKey;
        this.result = result;
        this.source = source;
        this.pagination = new SearchInfoPagination(1);
        this.pagination = pagination;
    }
}
__decorate([
    Type(() => SearchInfoPagination)
], SearchInfoWrapper.prototype, "pagination", void 0);
export class SearchInfoPagination {
    constructor(page, totalPage, next = undefined, youtube) {
        this.page = page;
        this.totalPage = totalPage;
        this.next = next;
        this.youtube = youtube;
    }
    hasNextPage() {
        if (!isBlank(this.youtube?.continuation)) {
            return true;
        }
        if (this.totalPage === undefined) {
            return true;
        }
        if (this.page >= this.totalPage) {
            return false;
        }
        return true;
    }
}
export class SearchInfoPaginationYoutube {
    constructor(key, continuation, context) {
        this.key = key;
        this.continuation = continuation;
        this.context = context;
    }
}
